import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { syncFiltersIntoQuery } from '../../../helpers/urlHelper';
import { history } from '../../../history';

const search = createSlice({
  name: 'search',
  initialState: {
    searchTagsOpenFrom: '',
    defaultSearchTags: [],
    globalCommonTags: [],
    searchTags: [],
    searchVal: '',
    searchResult: {},
    searchUserResult: null,
    searchOrgResult: null,
    allMyOrg: null,
    projectSearchValue: null,
  },
  reducers: {
    setGlobalCommonTags: (state, { payload }) => {
      state.globalCommonTags = payload;
    },
    setSearchTagsOpenFrom: (state, { payload }) => {
      state.searchTagsOpenFrom = payload;
    },
    setDefaultSearchTags: (state, { payload }) => {
      // when we set tags we want to keep selected state 
      const updatedPayload = keepTagsValues(state.defaultSearchTags, payload)
      state.defaultSearchTags = updatedPayload;
    },
    setSearchByTags: (state, { payload }) => {
      if (isEqual([...state.searchTags], payload)) return;
      state.searchTags = payload;
      syncTags(state.searchTags);
    },
    addSearchTag: (state, { payload }) => {
      state.searchTags.push(payload);

      syncTags(state.searchTags);
    },
    setTagsFromQuery: (state, { payload }) => {
      if (isEqual(state.searchTags, payload)) return;
      state.searchTags = payload;
    },
    removeSearchTag: (state, { payload }) => {
      state.searchTags = state.searchTags.filter(a => a !== payload);

      syncTags(state.searchTags);
    },
    setSearchValue: (state, { payload }) => {
      state.searchVal = payload;
    },
    setSearchValueFromQuery: (state, { payload }) => {
      if (payload === state.searchVal) return;
      state.searchVal = payload;
    },
    setSearchResult: (state, { payload }) => {
      state.searchResult = payload;
    },
    setMoreSearchResult: (state, { payload }) => {
      state.searchResult = {
        ...state?.searchResult,
        ...payload,
        results: [...state?.searchResult?.results, ...payload?.results],
      };
    },
    setSearchUserResult: (state, { payload }) => {
      state.searchUserResult = payload;
    },
    setSearchOrgResult: (state, { payload }) => {
      state.searchOrgResult = payload;
    },
    setAllOrgResult: (state, { payload }) => {
      state.allMyOrg = payload;
    },
    updateAllOrg: (state, { payload }) => {
      const { id, ...rest } = payload;
      if (!state.allMyOrg?.results) return;
      state.allMyOrg.results = state.allMyOrg.results.map(org => {
        return org.id === id ? { ...org, ...rest } : org;
      })
    },
    setprojectSearchValue: (state, { payload }) => {
      state.projectSearchValue = payload;
    },
  },
});

export const {
  setGlobalCommonTags,
  setSearchTagsOpenFrom,
  addSearchTag,
  setTagsFromQuery,
  removeSearchTag,
  setDefaultSearchTags,
  setSearchByTags,
  setSearchValue,
  setSearchResult,
  setSearchUserResult,
  setSearchOrgResult,
  setAllOrgResult,
  setprojectSearchValue,
  setMoreSearchResult,
  updateAllOrg,
  setSearchValueFromQuery,
} = search.actions;
export const searchSelector = (state) => state.search;
export const searchReducer = search.reducer;
export default searchReducer;


export const selectSearchOpenFrom = (state) => state.search.searchTagsOpenFrom;
export const selectSearchTags = (state) => state.search.searchTags;
export const selectDefaultSearchTags = (state) => state.search.defaultSearchTags;
export const selectSearchValue = (state) => state.search.searchVal;
export const selectSearchActive = (state) => state.search.searchVal.trim() !== '' || state.search.searchTagsOpenFrom == 'top';
export const selectGlobalCommonTags = (state) => state.search.globalCommonTags

export const getGlobalSearchFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get('s') || '';
}

const syncTags = (tags) => {
  const urlParams = new URLSearchParams(location.search);
  urlParams.delete('tags')

  if (tags.length) {
    urlParams.append('tags', tags.join('__'));
  }

  syncFiltersIntoQuery(urlParams)
}

export const getTagsFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  const tags = urlParams.get('tags') || '';
  return tags.split('__').filter(t => t);
}

function keepTagsValues(tags, payload) {
  return payload.map(p => {
    const currentState = tags.find(item => item.value === p.value);
    if (currentState) {
      return {
        ...p,
        selected: currentState.selected,
      }
    } else {
      return p;
    }
  })
}